import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6bd87a4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form" }
const _hoisted_2 = { class: "form__links" }
const _hoisted_3 = {
  key: 0,
  class: "link__error"
}
const _hoisted_4 = { class: "form__buttom-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_l_input = _resolveComponent("l-input")!
  const _component_l_color_suggested = _resolveComponent("l-color-suggested")!
  const _component_l_buttom = _resolveComponent("l-buttom")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("form", _hoisted_2, [
      _createVNode(_component_l_input, {
        input: "text",
        id: "link_input",
        value: _ctx.link,
        "onUpdate:input": _cache[0] || (_cache[0] = ($event: any) => (_ctx.link = $event)),
        pholder: "Link"
      }, null, 8, ["value"]),
      (_ctx.link_error)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, " El link tiene que tener más de 12 caracteres "))
        : _createCommentVNode("", true),
      _createVNode(_component_l_input, {
        input: "text",
        value: _ctx.name,
        id: "name_input",
        "onUpdate:input": _cache[1] || (_cache[1] = ($event: any) => (_ctx.name = $event)),
        onClick: _cache[2] || (_cache[2] = () => (_ctx.name = _ctx.getDomainName())),
        pholder: "Name"
      }, null, 8, ["value"]),
      _createVNode(_component_l_color_suggested, {
        name: _ctx.name,
        "selected-color": _ctx.selectedColor,
        "onUpdate:color": _cache[3] || (_cache[3] = (args) => (_ctx.selectedColor = args))
      }, null, 8, ["name", "selected-color"]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_l_buttom, {
          onClick: _ctx.saveLink,
          "onPick:color": _cache[4] || (_cache[4] = (args) => (_ctx.backgroundColor = args)),
          class: "form__links--buttom",
          text: _ctx.text_buttom
        }, null, 8, ["onClick", "text"])
      ])
    ])
  ]))
}